import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box } from '@chakra-ui/react';
import { Field } from 'formik';
import NameField from '@/components/forms/new/formikFormFields/NameField';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    formLabelStyling,
    stackStyling,
} from 'components/forms/new/formStyles';

const UserPlatformAttributes = ({
    errors,
    touched,
    darkMode,
    number,
    platformIndex,
}) => {
    const [isHovered, setIsHovered] = useState(false);
    const fieldName = `formValues[${platformIndex}].platformAttribute${number}`;

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={
                errors && fieldName in errors && touched && fieldName in touched
            }
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" sx={{ ...stackStyling(), width: '740px' }}>
                <Box width={174}>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Attribute {number}
                    </FormLabel>
                </Box>
                <Field
                    component={NameField}
                    width={488}
                    id={fieldName}
                    name={fieldName}
                />
                {isHovered && (
                    <FieldToolTip
                        label="Enter Platform Attribute"
                        ariaLabel={`platform-attribute-${number}-tip`}
                        right="40px"
                        top="23px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default UserPlatformAttributes;
